.paragraph {
  background-image: url("../images/text-paragraph.svg");
}

.h1 {
  background-image: url("../images/type-h1.svg");
}

.h2 {
  background-image: url("../images/type-h2.svg");
}

.h3 {
  background-image: url("../images/type-h3.svg");
}

.ul {
  background-image: url("../images/list-ul.svg");
}

.ol {
  background-image: url("../images/list-ol.svg");
}

.quote {
  background-image: url("../images/chat-square-quote.svg");
}

.code {
  background-image: url("../images/code.svg");
}
